/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} OptionsInputs */



/**
* | output |
* | --- |
* | "Options" |
*
* @param {OptionsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options = /** @type {((inputs?: OptionsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<OptionsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Options")
	if (locale === "de") return /** @type {LocalizedString} */ ("Optionen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Opzioni")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Параметры")
	if (locale === "es") return /** @type {LocalizedString} */ ("Opciones")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选项")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オプション")
	if (locale === "hi") return /** @type {LocalizedString} */ ("विकल्प")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Opções")
	return /** @type {LocalizedString} */ ("Options")
});